// FIXME: these should come from server
export const winCap = 32;
export const placeCap = 18;
export const showCap = 10;

const caps = {
  "W": winCap,
  "P": placeCap,
  "S": showCap
};

export function applyCap(score, betType) {
  return Math.min(score, caps[betType]);
}
